import React from "react";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import { IconContext } from "react-icons";
import classes from "./PortfolioElement.module.css"; // Use your CSS module

const PortfolioElement = (props: any) => {
  const iconsSize = {
    size: "1.5rem",
  };

  return (
    <div className={classes.container}>
      <div className={classes.title_container}>
        <h1>{props.title}</h1>
        {props.apis && props.apis.length > 0 && (
          <div className={classes.apiBadges}>
            {props.apis.map((api: any, index: any) => (
              <span key={index} className={classes.apiBadge}>
                {api}
              </span>
            ))}
          </div>
        )}
        <IconContext.Provider value={iconsSize}>
          <div className={classes.icons_container}>
            {props.icons.map((item: any, index: number) => {
              return <React.Fragment key={index}>{item}</React.Fragment>;
            })}
          </div>
        </IconContext.Provider>
        <div className={classes.linksSection}>
          <a
            href={props.github}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.actionLink}
          >
            <FaGithub />
            <span>GitHub</span>
          </a>
          <a
            href={props.sitelink}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.actionLink}
          >
            <FaExternalLinkAlt />
            <span>Live Site</span>
          </a>
        </div>
      </div>
      <img
        src={props.img}
        alt={`${props.title} screenshot`}
        className={classes.cardImage}
      />
      <div className={classes.contentArea}>
        <p className={classes.description}>
          {props.description.split("\n").map((text: string) => (
            <>
              <p>{text}</p>
              <br />
            </>
          ))}
        </p>
      </div>
    </div>
  );
};

export default PortfolioElement;
